export type SecurityReport = {
  id:number; frequency:string; period_start:string; period_end:string; created_at?:string;
  summary:{requests:number;serverErrors:number;firstObservation?:string;lastObservation?:string;errors?:{source:string;total:number}[];routes:{route:string;total:number}[]};
};
export function reportRows(report:SecurityReport,tr:(key:string)=>string):Array<[string,string|number]> {
  const summary=report.summary;
  return [
    [tr('Report'),tr(report.frequency==='current'?'Current security report':report.frequency==='daily'?'Daily report':'Weekly report')],
    [tr('Report ID'),report.frequency==='current'?'—':report.id],
    [tr('Period start UTC'),report.period_start],
    [tr('Period end UTC exclusive'),report.period_end],
    [tr('Generated at UTC'),report.created_at||'—'],
    [tr('Requests'),summary.requests],
    ['HTTP 5xx',summary.serverErrors],
    [tr('First observation UTC'),summary.firstObservation||'—'],
    [tr('Last observation UTC'),summary.lastObservation||'—'],
    ...(summary.errors||[]).map(row=>[`${tr('Error sources')} — ${row.source}`,row.total] as [string,number]),
    ...summary.routes.map(row=>[`${tr('Affected routes')} — ${row.route}`,row.total] as [string,number]),
    [tr('Coverage'),tr('Security report export coverage')]
  ];
}
export async function downloadSecurityReport(report:SecurityReport,format:'pdf'|'xlsx',tr:(key:string)=>string){
  const rows=reportRows(report,tr),headers=[tr('Metric'),tr('Value')];
  const filename=`GeoTracking-security-${report.frequency==='current'?'current':report.frequency==='daily'?'daily':'weekly'}-${report.period_start.slice(0,10)}-${report.id}`;
  let blob:Blob;
  if(format==='xlsx'){
    const {default:ExcelJS}=await import('exceljs');
    const workbook=new ExcelJS.Workbook();
    const sheet=workbook.addWorksheet('GeoTracking');
    sheet.columns=[{width:42},{width:100}];
    sheet.addRow(headers).font={bold:true,color:{argb:'FFFFFFFF'}};
    sheet.getRow(1).fill={type:'pattern',pattern:'solid',fgColor:{argb:'FFFF801A'}};
    rows.forEach(row=>sheet.addRow(row));
    sheet.eachRow(row=>{row.alignment={vertical:'top',wrapText:true};});
    blob=new Blob([await workbook.xlsx.writeBuffer()],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
  }else{
    const [{jsPDF},{default:autoTable}]=await Promise.all([import('jspdf'),import('jspdf-autotable')]);
    const doc=new jsPDF();
    doc.setFontSize(16);doc.text('GeoTracking',14,18);
    autoTable(doc,{head:[headers],body:rows,startY:26,styles:{fontSize:10,overflow:'linebreak',cellPadding:3},headStyles:{fillColor:[255,128,26]},columnStyles:{0:{cellWidth:65}},margin:{top:20,bottom:20}});
    blob=doc.output('blob');
  }
  const url=URL.createObjectURL(blob),link=document.createElement('a');
  link.href=url;link.download=filename+'.'+format;document.body.appendChild(link);
  try{link.click();}finally{link.remove();setTimeout(()=>URL.revokeObjectURL(url),1000);}
}
